var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLudoActiveicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 18.1309C5.42177 18.1309 6.625 16.9276 6.625 15.4434C6.625 13.9591 5.42177 12.7559 3.9375 12.7559C2.45323 12.7559 1.25 13.9591 1.25 15.4434C1.25 16.9276 2.45323 18.1309 3.9375 18.1309Z",
    stroke: "#BD3193",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3125 18.1309C10.7968 18.1309 12 16.9276 12 15.4434C12 13.9591 10.7968 12.7559 9.3125 12.7559C7.82823 12.7559 6.625 13.9591 6.625 15.4434C6.625 16.9276 7.82823 18.1309 9.3125 18.1309Z",
    stroke: "#BD3193",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 18.1309C16.1718 18.1309 17.375 16.9276 17.375 15.4434C17.375 13.9591 16.1718 12.7559 14.6875 12.7559C13.2032 12.7559 12 13.9591 12 15.4434C12 16.9276 13.2032 18.1309 14.6875 18.1309Z",
    stroke: "#BD3193",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 18.1309C21.5468 18.1309 22.75 16.9276 22.75 15.4434C22.75 13.9591 21.5468 12.7559 20.0625 12.7559C18.5782 12.7559 17.375 13.9591 17.375 15.4434C17.375 16.9276 18.5782 18.1309 20.0625 18.1309Z",
    stroke: "#BD3193",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.86914L13.875 8.36914L12 5.86914L10.125 8.36914L8.25 5.86914V11.0186H15.75V5.86914Z",
    stroke: "#BD3193",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudoActiveicon);
export default __webpack_public_path__ + "static/media/LudoActiveicon.32e70cb5c9dd20540ee191c643431fe9.svg";
export { ForwardRef as ReactComponent };